import React from 'react'
import { AppRouteProps } from '~/routes'
import AuditQualifiers from './pages/AuditQualifiers'
import AuditInterestPoint from './pages/AuditInterestPoint'
import AuditUserActions from './pages/AuditUserActions'
import AuditUserLoginLogout from './pages/AuditUserLoginLogout'
import AuditKeywords from './pages/AuditKeywords'
import AuditUserActionsReport from './pages/AuditUserActionsReports'
import AuditDevices from './pages/AuditDevices'
import AuditDispatchGroupReport from './pages/AuditDispatchGroupReport'
import AuditUserGroupReport from './pages/AuditUserGroupReport'
import AuditDispatchStatisticsReport from './pages/AuditDispatchStatisticsReport'
import AuditUsersReport from './pages/AuditUsersReport'
import AuditStationReport from './pages/AuditStationReport'
import AuditPrintOccurrence from './pages/AuditPrintOccurrence'
import ScaleAudit from './pages/ScaleAudit'
export default function SearchLogsRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/audit-qualifiers',
      component: AuditQualifiers,
      isProtected: true,
    },
    {
      path: '/audit-interest-point',
      component: AuditInterestPoint,
      isProtected: true,
    },
    {
      path: '/audit-user-actions',
      component: AuditUserActions,
      isProtected: true,
    },
    {
      path: '/audit-user-loginLogout',
      component: AuditUserLoginLogout,
      isProtected: true,
    },
    {
      path: '/audit-keywords',
      component: AuditKeywords,
      isProtected: true,
    },
    {
      path: '/audit-user-actions-report',
      component: AuditUserActionsReport,
      isProtected: true,
    },
    {
      path: '/audit-user-device',
      component: AuditDevices,
      isProtected: true,
    },
    {
      path: '/audit-user-dispatch-group',
      component: AuditDispatchGroupReport,
      isProtected: true,
    },
    {
      path: '/audit-user-group',
      component: AuditUserGroupReport,
      isProtected: true,
    },
    {
      path: '/audit-dispatch-statistics',
      component: AuditDispatchStatisticsReport,
      isProtected: true,
    },
    {
      path: '/audit-users',
      component: AuditUsersReport,
      isProtected: true,
    },
    {
      path: '/audit-scale',
      component: ScaleAudit,
      isProtected: true,
      permissions: ['audit_work_schedule_action_logs'],
    },
    {
      path: '/audit-station',
      component: AuditStationReport,
      isProtected: true,
    },
    {
      path: '/audit-print-occurrence',
      component: AuditPrintOccurrence,
      isProtected: true,
    },
  ]
  return routes
}
